import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { setAdminCsrfToken } from "../lib/adminApi";

interface Props {
  component: React.ComponentType;
}

export function AdminGuard({ component: Component }: Props) {
  const [, setLocation] = useLocation();
  const [checking, setChecking] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch("/api/admin/me", { credentials: "include" })
      .then((res) => res.json())
      .then((data: { authenticated: boolean; csrfToken?: string }) => {
        if (cancelled) return;
        if (data.authenticated) {
          // Stash CSRF token before any mutating admin call has a chance
          // to fire — every POST/PUT/PATCH/DELETE under /api/admin/* is
          // gated on this header server-side.
          if (data.csrfToken) setAdminCsrfToken(data.csrfToken);
          setAuthenticated(true);
        } else {
          setAdminCsrfToken(null);
          setLocation("/admin/login");
        }
      })
      .catch(() => {
        if (!cancelled) setLocation("/admin/login");
      })
      .finally(() => {
        if (!cancelled) setChecking(false);
      });
    return () => { cancelled = true; };
  }, [setLocation]);

  if (checking) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center">
        <div className="text-gray-500 text-sm">Verifying access…</div>
      </div>
    );
  }

  if (!authenticated) return null;

  return <Component />;
}
